export function extractEditor(
  div: HTMLDivElement | string,
): HTMLElement | Document {
  let doc: HTMLElement | Document;
  if (typeof div === "string") {
    const parser = new DOMParser();
    doc = parser.parseFromString(div, "text/html");
  } else {
    doc = div;
  }

  return doc;
}
